import PropTypes from 'prop-types';
import { useMemo } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Dotdotdot } from '@hivebrite/design-system/Dotdotdot';
import { Image } from '@hivebrite/design-system/Image';
import { breakText, linkEffect } from '@hivebrite/design-system/Theme';

import { Link } from 'hb-react/frontoffice/components/Link';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';
import { completeName } from 'helpers/name';

const UserRow = ({ user, userNameFormat = completeName }) => {
  const { flagEvUserPicturesToGlobalStorage } = useFeatureFlag();
  const userUrl = useMemo(() => Routes.user_path(user.id), [user]);
  const picture = useMemo(
    () => (
      <Image
        src={
          flagEvUserPicturesToGlobalStorage
            ? user.new_photo?.thumbnail_url
            : user.photo_thumb_url
        }
        alt=""
      />
    ),
    [user],
  );

  return (
    <Link to={userUrl}>
      {/* 2px margin is to ensure the outline is visible (and not hidden when the parent
        container has "overflow: hidden" or equivalent) when tab-navigating to the user rows. */}
      <Box alignItems="center" m="2px">
        <AvatarWrapper>{picture}</AvatarWrapper>
        <Box flex={1} pr={2} py={2}>
          <UserName>
            <Dotdotdot clamp={2}>{userNameFormat(user)}</Dotdotdot>
          </UserName>
        </Box>
      </Box>
    </Link>
  );
};

UserRow.propTypes = {
  user: PropTypes.object.isRequired,
};

export default UserRow;

const AvatarWrapper = styled(Box).attrs(() => ({
  height: 60,
  width: 60,
  mr: 4,
}))`
  border-radius: 50%;
  user-select: none;
  ${breakText}

  img {
    border-radius: 50%;
    width: inherit;
  }
`;
const UserName = styled(Box).attrs(() => ({
  display: 'inline',
  font: 'h4-semibold',
}))`
  ${linkEffect}
`;
